// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--7Bht7","icon":"dd31006766--icon--3HCXQ","message":"dd31006766--message--1CcTl"};